import { ArrowUpRight, ShieldCheck } from "lucide-react";

const HERO_IMG = "https://images.unsplash.com/photo-1701854851797-59656d43e5fe";

const go = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden bubaloo-grain"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Suited executive protection professional in cinematic dark lighting"
          className="h-full w-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 hero-gradient hidden md:block" />
        <div className="absolute inset-0 hero-gradient-mobile md:hidden" />
      </div>

      {/* Subtle top fade for navbar legibility */}
      <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/80 to-transparent z-10" />

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 sm:px-8 min-h-[100svh] flex flex-col justify-end pb-20 pt-32">
        <div className="max-w-3xl">
          <div className="fade-up flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-[#1A5C40]" />
            <span className="overline">
              Private Security · DMV · Baltimore · Maryland
            </span>
          </div>

          <h1 className="font-display fade-up fade-up-delay-1 text-5xl sm:text-6xl lg:text-7xl text-white font-light leading-[1.02] tracking-tight">
            Protection
            <br />
            <span className="text-zinc-400">without</span> compromise.
          </h1>

          <p className="fade-up fade-up-delay-2 mt-8 max-w-xl text-base sm:text-lg text-zinc-300 leading-relaxed">
            Corporate, retail, executive, religious institution, and VIP
            security delivered by highly trained professionals — including
            active &amp; retired military and law enforcement.
          </p>

          <div className="fade-up fade-up-delay-3 mt-10 flex flex-wrap items-center gap-4">
            <button
              onClick={() => go("inquiry")}
              data-testid="hero-cta-primary"
              className="btn-primary"
            >
              Request Protection Details
              <ArrowUpRight size={16} strokeWidth={1.5} />
            </button>
            <button
              onClick={() => go("services")}
              data-testid="hero-cta-secondary"
              className="btn-outline"
            >
              Explore Services
            </button>
          </div>

          <div className="fade-up fade-up-delay-4 mt-14 grid grid-cols-3 gap-6 max-w-xl border-t border-white/10 pt-6">
            <div>
              <div className="font-display text-2xl text-white">24 / 7</div>
              <div className="overline mt-1">Rapid Response</div>
            </div>
            <div>
              <div className="font-display text-2xl text-white">100%</div>
              <div className="overline mt-1">Vetted Agents</div>
            </div>
            <div>
              <div className="font-display text-2xl text-white">DMV</div>
              <div className="overline mt-1">Service Region</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative bottom strip */}
      <div className="absolute bottom-0 inset-x-0 z-20 border-t border-white/5 bg-black/60 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-4 flex items-center justify-between text-xs text-zinc-500">
          <div className="flex items-center gap-3">
            <ShieldCheck size={14} className="text-[#1A5C40]" strokeWidth={1.5} />
            <span className="tracking-[0.18em] uppercase">
              Discreet · Trained · Trusted
            </span>
          </div>
          <div className="hidden sm:block tracking-[0.18em] uppercase">
            Serving the DMV, Baltimore &amp; Maryland
          </div>
        </div>
      </div>
    </section>
  );
}
